export default {
  state: {
    nowDate: null,            // 当前时间的时间戳
    timeDifference: 0,        // 和服务端时间差
    timeDiff: 0,              // 本地时间和服务器时间差
    isTrans: 0    // 手机旋转角度
  },
  mutations: {
    set_isTrans (state, val) {
      state.isTrans = val
    },
    set_nowDate (state, val) {
      state.nowDate = val
    },
    set_timeDifference (state, val) {
      state.timeDifference = val
    },
    set_timeDiff (state, val) {
      state.timeDiff = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/isTrans.js